import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";

import Button from "../../components/button";
import ICDateInput from "../../components/form/dateInput";
import MakeAPICall from "../../apiCalls/common";
import { rotateMIMSKeysApiRoute } from "../../apiRoutes";

const MIMSConfigForm = props => {
  const [apiCallParams, setApiCallParams] = useState(null);
  const [isRotating, setIsRotating] = useState(false);

  // Debug logging
  console.log("MIMSConfigForm props.data:", props.data);
  console.log("MIMSConfigForm mimsConfig:", props.data?.mimsConfig);

  // Helper function to convert ISO string to Date object
  const convertToDate = (dateString) => {
    if (!dateString) return null;
    try {
      return new Date(dateString);
    } catch (error) {
      console.error("Error converting date:", error);
      return null;
    }
  };

  const handleRotateKeys = () => {
    setIsRotating(true);
    setApiCallParams({
      reqType: "POST",
      reqUrl: rotateMIMSKeysApiRoute,
      successCallback: res => {
        setIsRotating(false);
        if (props.onRotateSuccess) {
          props.onRotateSuccess("MIMS API Keys rotated successfully");
        }
      },
      failureCallback: err => {
        setIsRotating(false);
        if (props.onRotateError) {
          props.onRotateError(err.message || "Failed to rotate MIMS API Keys");
        }
      }
    });
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      endUserLicenseAgreementRevisionDate: convertToDate(props.data?.mimsConfig?.endUserLicenseAgreementRevisionDate)
    },
    validationSchema: Yup.object({
      endUserLicenseAgreementRevisionDate: Yup.date().nullable()
    }),
    onSubmit: values => {
      console.log("MIMS Config submit", values);
      props.onFormSubmit(values);
    }
  });


  return (
    <div className="card custom-card-outlined">
      <h5 className="card-header">MIMS Configuration</h5>
      <div className="card-body">
        <form onSubmit={formik.handleSubmit}>
          <div className="row mb-3">
            <p className="col-md-6 font-weight-bold">End User License Agreement Revision Date</p>
            <div className="col-md-6">
              <ICDateInput
                id="endUserLicenseAgreementRevisionDate"
                name="endUserLicenseAgreementRevisionDate"
                defaultDate={formik.values.endUserLicenseAgreementRevisionDate}
                handleChange={(date) => {
                  formik.setFieldValue("endUserLicenseAgreementRevisionDate", date);
                }}
                error={formik.touched.endUserLicenseAgreementRevisionDate && formik.errors.endUserLicenseAgreementRevisionDate ? true : false}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 text-center">
              <Button
                className="mt-2"
                title="Update MIMS Config"
                type="submit"
                disabled={props.isProcessing}
              />
            </div>
          </div>
        </form>
        <hr />
        <div className="row">
          <div className="col-md-12 text-center">
            <Button
              className="mt-2"
              title="Rotate MIMS API Keys"
              clickEvent={handleRotateKeys}
              disabled={isRotating || props.isProcessing}
            />
          </div>
        </div>
      </div>
      <MakeAPICall apiParam={apiCallParams} />
    </div>
  );
};

export default MIMSConfigForm;

MIMSConfigForm.defaultProps = {
  serverErrorMsg: "",
  successMsg: "",
  onRotateSuccess: null,
  onRotateError: null
};

MIMSConfigForm.propTypes = {
  onFormSubmit: PropTypes.func,
  serverErrorMsg: PropTypes.string,
  successMsg: PropTypes.string,
  data: PropTypes.object,
  isProcessing: PropTypes.bool,
  onRotateSuccess: PropTypes.func,
  onRotateError: PropTypes.func
};